module.exports = __webpack_public_path__ + "static/lentochnyi-fundament-6507babd582278d7f7f7a40c25d2c968.jpg";